//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TeamMember from '../vue/TeamMember.vue';

export default {
  data() {
      return {
        show: false,
      };
  },
  
  props: {
    team_members: {
    },
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {
    TeamMember,
  },
  
  created() {
    
  },
  mounted() {
  },
};




// WEBPACK FOOTER //
// ./scripts/vue/TeamMemberContainer.vue